import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { Link } from "react-router-dom";
import "./Navbar.scss";
import { useState } from "react";

function Navbar() {
  const [click, setClick] = useState(false);

  const hide = () => {
    setClick(!click);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light  ">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={hide}></Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#menubar"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={hide}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={
            click
              ? "collapse navbar-collapse show"
              : "collapse navbar-collapse hide"
          }
          id="menubar"
        >
          <ul className="navbar-nav m-auto ">
            <li className="nav-item ">
              <Link
                className="nav-link active"
                aria-current="page"
                to="/"
                onClick={hide}
              >
                HOME
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/men" onClick={hide}>
                MEN
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/women" onClick={hide}>
                WOMEN
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/care" onClick={hide}>
                FACE & BODY
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contact" onClick={hide}>
                CONTACT
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
